export default __webpack_public_path__ + "static/media/baby.56cc4909.gif";